<script>
export default {
  name: "Footer"
};
</script>

<template>
  <div id="footer">
    <div class="footer-container-up">
      <div class="footer-text-container">
        <div>
          <img class="logo" src="../assets/logo.png" alt="Company Logo">
          <span class="is-bold">ネクストダイナ株式会社</span>
        </div>
        <div class="company-description">
          <span class="is-bold">次世代への原動力</span>
          <span class="is-bold">nextDyna Co., Ltd.</span>
        </div>
      </div>
      <div class="footer-info-container">
        <div class="information">
          <span class="is-bold">Information</span>
          <router-link to="/" tag="div">ホーム</router-link>
          <router-link to="/services" tag="div">事業内容／サービス</router-link>
          <router-link to="/about" tag="div">会社概要</router-link>
          <router-link to="/fundamentalpolicy" tag="div">情報セキュリティ方針</router-link>
        </div>
        <div class="access">
          <span class="is-bold">Access</span>
          <span>〒136-0072</span>
          <span>東京都</span>
          <span>江東区大島２－１０ー１７</span>
          <span>ネオコーボ西大島Ⅱ ５階</span>
        </div>
      </div>
    </div>
    <div class="footer-container-bottom">
      <span>https://nextdyna.co.jp/</span>
      <span>Copyright(c) 2025 nextDyna Co., Ltd. All Rights Reserved</span>
    </div>
  </div>
</template>

<style scoped>
#footer {
  border-top: 1px solid #EAECEF;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  text-align: center;
  display: flex;
  flex-direction: column;
}

.footer-container-up {
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #EEEEEC;
  margin-top: 10px;
}

.footer-text-container {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
}

.footer-text-container span {
  margin: 0 0 1px 0;
}

.footer-container-bottom {
  flex: 0.1;
  display: flex;
  justify-content: space-between;
}

.footer-info-container {
  display: flex;
  width: 50%;
  justify-content: space-around;
}

.access {
  display: flex;
  flex-direction: column;
}
.logo {
  height: 40px;
  width: auto;
  vertical-align: middle;
}
.company-description{
  display: flex;
  flex-direction: column;
  margin-left: 40px;
}
.is-bold {
  font-weight: bolder;
  font-size: large;
}

.information div {
  cursor: pointer;
}

.information div:hover {
  color: #409EFF;
}

@media (max-width: 960px) {
  .footer-container-up,
  .footer-info-container {
    flex-direction: column;
  }

  .footer-info-container {
    width: 100%
  }
  .footer-text-container{
    margin-left: 20px;
  }
  .information {
    margin-bottom: 50px;
  }
}
</style>